import { render } from "./Loader.vue?vue&type=template&id=1456b2ea"
const script = {}

import exportComponent from "/Users/mattday/Sites/swallowdental.co.uk/app/code/SwallowDental/CustomAccount/view/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"web/vue/components/Loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1456b2ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1456b2ea', __exports__)) {
    api.reload('1456b2ea', __exports__)
  }
  
  module.hot.accept("./Loader.vue?vue&type=template&id=1456b2ea", () => {
    api.rerender('1456b2ea', render)
  })

}


export default __exports__